import { PayInMethodsResp } from 'types/api/response/pay-in-methods-resp'

import { api } from './api'

export const getTransactionPayInMethods = (transactionId: number) =>
  api.get<PayInMethodsResp>(`/transactions/${transactionId}/pay_in_methods`)
